module.exports = __webpack_public_path__ + "static/media/artists.82e833e3.png";